import React from 'react';

import HeadCalendar from './HeadCalendar';
import SmallMonthRows from './SmallMonthRows';
import { SmallCalendarPropsType } from '../types';

const SmallCalendar = ({ monthShown, newSelectedDates, click, newData, currentDate }: SmallCalendarPropsType) => {
  return (
    <div className="calendar-w">
      <HeadCalendar date={monthShown} />
      <SmallMonthRows
        monthShown={monthShown}
        selectedDates={newSelectedDates}
        click={click}
        newData={newData}
        currentDate={currentDate}
      />
    </div>
  );
};

export default SmallCalendar;